
export const LibraryLoadingSkeleton = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {[...Array(8)].map((_, i) => (
        <div key={i} className="h-[360px] bg-gray-100 rounded-lg animate-pulse" />
      ))}
    </div>
  );
};
